import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { PrematriculaWizard } from '../../../features/prematricula-wizard/prematricula-wizard';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: true,
  selector: 'app-aluno-matricula-card',
  templateUrl: './aluno-matricula-card.html',
  styleUrls: ['./aluno-matricula-card.scss'],
  imports: [MatIconModule]
})
export class AlunoMatriculaCardComponent {
  @Input() nome: string = '';
  @Input() anoLetivo: string = '';
  @Input() alunoId: number = 0;
  @Input() anoLetivoId: number = 0;

    // 👉 Aqui você recebe a função do pai
  @Input() onMatriculaAtualizada?: () => void;

  constructor(
    public dialog: MatDialog,

  ) {}

  ngOnInit() {
  }

  abrirPrematriculaDialog() {
    const dialogRef = this.dialog.open(PrematriculaWizard, {

      data: {
        alunoId: this.alunoId,
        anoLetivoId: this.anoLetivoId,
        anoLetivo: this.anoLetivo
      },
      // maxHeight: '100%',
      // maxWidth: '100%'
      width: '70%',
      height: '100vh',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (this.onMatriculaAtualizada) {
        this.onMatriculaAtualizada(); // chama a função do pai
      }
    });
  }
}
